import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import axios from "axios";

function UnsPatientCard(props) {
    const addPatient = () => {
        console.log(`/signMePatient/${props.patient.patientId}/${localStorage.getItem("user")}`);
    axios
      .get(
        `/signMePatient/${props.patient.patientId}/${localStorage.getItem("user")}`
      )
      .then((res) => {
        console.log(res.data);
      window.location.reload();

      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Card className="card">
      <CardContent>
        <h1
          style={{
            backgroundColor: "#3f51b5",
            color: "white",
            borderRadius: 8,
          }}
        >
          {props.patient.name}
        </h1>
        <Typography
          //   className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {props.patient.email}
        </Typography>

        <Button variant="contained" color="secondary" onClick={addPatient}>
          Add patient
        </Button>
      </CardContent>
    </Card>
  );
}

export default UnsPatientCard;
